import { create } from 'zustand'

import { reduce } from '../lib/storeNudgeMachine'

import type {
  StoreNudgeEvent,
  StoreNudgeMachineState,
  StoreNudgeSeenState
} from './types'

type StoreNudgeStore = {
  /** Chave de storage a que `seen` e `machine` pertencem. */
  key: string | null
  seen: StoreNudgeSeenState | null
  machine: StoreNudgeMachineState | null
  hydrate: (input: {
    key: string
    seen: StoreNudgeSeenState
    machine: StoreNudgeMachineState
  }) => void
  setSeen: (seen: StoreNudgeSeenState) => void
  dispatch: (event: StoreNudgeEvent) => void
  reset: () => void
}

/**
 * Estado do nudge fora do React.
 *
 * O host desmonta durante um nível (`Layout` troca o shell inteiro pelo
 * `PassthroughShell`), e um lote em `collecting` não pode ser perdido nesse
 * intervalo. Zustand de módulo sobrevive ao desmonte; o storage cobre a recarga.
 */
export const useStoreNudgeStore = create<StoreNudgeStore>((set, get) => ({
  key: null,
  seen: null,
  machine: null,
  hydrate: ({ key, seen, machine }) => set({ key, seen, machine }),
  setSeen: seen => set({ seen }),
  dispatch: event => {
    const { machine } = get()
    if (!machine) return
    const next = reduce(machine, event)
    if (next !== machine) set({ machine: next })
  },
  reset: () => set({ key: null, seen: null, machine: null })
}))
